Object.defineProperty(exports,"__esModule",{value:true});exports.default=MaskedView;function MaskedView(_ref){var children=_ref.children;return children;}